import React, { useEffect, useRef, useState, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '../../context/auth0';
import { ModalCustomerSignup } from '../modals';
import { action_openModalLikeListing } from '../data/isOpenModalLikeListing';
import { useClickEventOnDocument } from '../../hooks/useClickEventOnDocument';
import pages from '../../define/pages';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';
import HeaderMenu, { HeaderMenuStyles } from './HeaderMenu';
import Button, { ButtonSizes } from '../Button/Button';
import { DROPDOWN_POSITIONS } from '../../../constants';
import { Dropdown } from '../common/Dropdown';
import { ButtonStyles } from '../Button/Button';
import CircleCard, { CircleCardSizes } from '../CircleCard/CircleCard';
import endpoints from '../../define/endpoints';
import { ROLES } from '../../../constants';
import { getGiftIdeas } from '../../hooks/getGiftIdeas';
import Typography, {
  TypographyVariants,
} from '../../ui-components/Typography/Typography';
import { TRANSLATIONS } from '../../../translations';

const ViewDesktop = (props) => {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, user } =
    useAuth0();

  const ref = useRef();
  const isSpanishEnv = freedomeConfig.baseLocale === 'es';

  const isTransparent = props.navbarStyle;
  const dispatch = useDispatch();

  const baseClass = 'navbar__menu';

  const [isCategoriesDropdownOpen, setIsCategoriesDropdownOpen] =
    React.useState(false);
  const [isSecondaryMenuOpen, setIsSecondaryMenuOpen] = React.useState(false);

  const [toggleGiftIdeasDropdown, setToggleGiftIdeasDropdown] = useState(false);

  const rightDelimiterRef = useRef();
  const rightDelimiterForDropdown = rightDelimiterRef.current
    ? rightDelimiterRef.current.getBoundingClientRect().right
    : null;

  const [togglePopularDropdown, setTogglePopularDropdown] = useState(false);
  const [toggleEarthDropdown, setToggleEarthDropdown] = useState(false);
  const [toggleSnowDropdown, setToggleSnowDropdown] = useState(false);
  const [toggleAirDropdown, setToggleAirDropdown] = useState(false);
  const [toggleFireDropdown, setToggleFireDropdown] = useState(false);
  const [toggleWaterDropdown, setToggleWaterDropdown] = useState(false);

  const popularCategories = props.mostPopularCategories;
  const giftIdeas = useMemo(() => getGiftIdeas(isSpanishEnv), []);

  const [isLanguagesDropdownOpen, setIsLanguagesDropdownOpen] =
    React.useState(false);
  const [isPersonalAreaDropdownOpen, setIsPersonalAreaDropdownOpen] =
    React.useState(false);
  const profile = () => {
    if (user && user.profile_image) {
      var imageSource =
        user.profile_image &&
          (user.profile_image.startsWith('https://') ||
            user.profile_image.startsWith('blob'))
          ? user.profile_image
          : `${endpoints.bucket}${user.profile_image}`;

      return (
        <div className="avatar avatar--16">
          <img src={imageSource} alt="user-profile" />
        </div>
      );
    } else {
      return (
        <BetaIcon
          name={'user'}
          color={isTransparent ? IconColors.ghost : IconColors.regular}
          size={IconSizes[16]}
        />
      );
    }
  };
  const generateQuery = (categories, redirect) => {
    const categoryParam = categories.join('%2C');
    return `${baseUrl.replace('/en', '')}${redirect}?category=${categoryParam}`;
  };
  const baseUrl = window.freedomeConfig.endpoints.base_url;
  const chevronUp = (
    <BetaIcon
      name={'chevronUp'}
      color={isTransparent ? IconColors.ghost : IconColors.regular}
      size={IconSizes[16]}
    />
  );
  const chevronDown = (
    <BetaIcon
      name={'chevronDown'}
      color={isTransparent ? IconColors.ghost : IconColors.regular}
      size={IconSizes[16]}
    />
  );

  const closeAllDropdowns = () => {
    setTogglePopularDropdown(false);
    setToggleEarthDropdown(false);
    setToggleSnowDropdown(false);
    setToggleAirDropdown(false);
    setToggleFireDropdown(false);
    setToggleWaterDropdown(false);
    setToggleGiftIdeasDropdown(false);
  };

  const ToggleSecondaryMenu = (open) => {
    closeAllDropdowns();
    setIsSecondaryMenuOpen(open);
    setTimeout(() => setTogglePopularDropdown(open), 200);
  };

  const categorySectionMaker = (c) => {
    let dropdownToggle;
    let setDropdownToggle;
    let label;
    let icon;

    if (c.categories.length === 0) {
      return null;
    }

    switch (c.parent_id) {
      case 1: //water
        dropdownToggle = toggleWaterDropdown;
        setDropdownToggle = setToggleWaterDropdown;
        label = app_main_wpml.water;
        icon = (
          <BetaIcon
            name={'water'}
            color={IconColors.regular}
            size={IconSizes[16]}
          />
        );
        break;
      case 2: //earth
        dropdownToggle = toggleEarthDropdown;
        setDropdownToggle = setToggleEarthDropdown;
        label = app_main_wpml.earth;
        icon = (
          <BetaIcon
            name={'earth'}
            color={IconColors.regular}
            size={IconSizes[16]}
          />
        );
        break;
      case 3: //air
        dropdownToggle = toggleAirDropdown;
        setDropdownToggle = setToggleAirDropdown;
        label = app_main_wpml.air;
        icon = (
          <BetaIcon
            name={'air'}
            color={IconColors.regular}
            size={IconSizes[16]}
          />
        );
        break;
      case 4: //fire
        dropdownToggle = toggleFireDropdown;
        setDropdownToggle = setToggleFireDropdown;
        label = app_main_wpml.fire;
        icon = (
          <BetaIcon
            name={'fire'}
            color={IconColors.regular}
            size={IconSizes[16]}
          />
        );
        break;
      case 5: //snow
        dropdownToggle = toggleSnowDropdown;
        setDropdownToggle = setToggleSnowDropdown;
        label = app_main_wpml.snow;
        icon = (
          <BetaIcon
            name={'snow'}
            color={IconColors.regular}
            size={IconSizes[16]}
          />
        );
        break;
    }

    return (
      <>
        <Button
          key={c.parent_id + 'b'}
          style={ButtonStyles.textUnderlined}
          label={label}
          iconLeft={icon}
          onClick={() => {
            closeAllDropdowns();
            setDropdownToggle(!dropdownToggle);
          }}
        />
        <Dropdown
          key={c.parent_id + 'd'}
          isBeta={true}
          position={DROPDOWN_POSITIONS.NAVBAR_SECONDARY}
          isOpen={dropdownToggle}
          rightestPixel={rightDelimiterForDropdown}
        >
          {dropDownContentFromCategories(c.categories, pages.catalogue)}
        </Dropdown>
      </>
    );
  };

  const dropDownContentFromCategories = (cs, redirect, noQuery = false) => {
    const ids = cs.map((category) => category.id);
    const urlString = noQuery ? redirect : generateQuery(ids, redirect);

    const highlightedCategories = cs.slice(0, 6);
    const highlightsCards = highlightedCategories.map((c) => {
      return (
        <CircleCard
          key={c.id}
          caption={c.title}
          link={`${baseUrl}/${c.slug}/`}
          image={c.thumbnail_image}
        />
      );
    });
    const otherCategories = cs.slice(6);
    const otherCards = otherCategories.map((c) => {
      return (
        <CircleCard
          key={c.id}
          size={CircleCardSizes.small}
          caption={c.title}
          link={`${baseUrl}/${c.slug}/`}
          image={c.thumbnail_image}
        />
      );
    });

    return (
      <div className="dropdown__sections-wrapper">
        <div className="dropdown__section">{highlightsCards}</div>
        <div className="dropdown__divider" />
        <div className="dropdown__section">
          {otherCards}
          <Button
            style={ButtonStyles.empty}
            label={
              <Typography variant={TypographyVariants.p3}>
                {app_main_wpml.all_activities}
              </Typography>
            }
            size={ButtonSizes.xs}
            redirect={urlString}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        ToggleSecondaryMenu(false);
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  useClickEventOnDocument([isCategoriesDropdownOpen], () => {
    isCategoriesDropdownOpen && setIsCategoriesDropdownOpen(false);
  });

  useClickEventOnDocument([isLanguagesDropdownOpen], () => {
    isLanguagesDropdownOpen && setIsLanguagesDropdownOpen(false);
  });

  useClickEventOnDocument([isPersonalAreaDropdownOpen], () => {
    isPersonalAreaDropdownOpen && setIsPersonalAreaDropdownOpen(false);
  });

  const transitionProps = {
    classNames: baseClass,
    in: !isLoading,
    mountOnEnter: true,
    unmountOnExit: true,
    appear: true,
    timeout: 200,
  };

  let language_fullname = freedomeConfig.baseLocale.toUpperCase();
  freedomeConfig.languages.map((language) => {
    if (language.code == freedomeConfig.locale)
      language_fullname = language.code.toUpperCase();
  });

  return (
    <div ref={ref} style={{ margin: '1px' }}>
      <CSSTransition ref={ref} {...transitionProps}>
        <HeaderMenu
          isOpen={true}
          rightChildren={[
            <div key={app_main_wpml.gift_ideas}>
              {freedomeConfig.locale != 'en' && (
                <div style={{ position: 'relative' }}>
                  <Button
                    style={
                      isTransparent
                        ? ButtonStyles.textInvertUnderlined
                        : ButtonStyles.textUnderlined
                    }
                    label={app_main_wpml.gift_ideas}
                    iconLeft={
                      <BetaIcon
                        name={'gift'}
                        color={
                          isTransparent ? IconColors.ghost : IconColors.regular
                        }
                        size={IconSizes[16]}
                      />
                    }
                    iconRight={
                      toggleGiftIdeasDropdown ? chevronUp : chevronDown
                    }
                    onClick={() => {
                      ToggleSecondaryMenu(false);
                      setToggleGiftIdeasDropdown(!toggleGiftIdeasDropdown);
                    }}
                  />
                  <Dropdown
                    isBeta={true}
                    position={DROPDOWN_POSITIONS.NAVBAR}
                    isOpen={toggleGiftIdeasDropdown}
                  >
                    <div className="dropdown__sections-wrapper">
                      <div className="dropdown__giftcard">
                        <h6>{TRANSLATIONS.GIFTCARD_BOX_TITLE}</h6>
                        <p>
                          <strong>{TRANSLATIONS.GIFTCARD_TITLE}</strong>
                          <br />
                          {TRANSLATIONS.GIFTCARD_BOX_DESCRIPTION}
                        </p>
                        <Button
                          style={ButtonStyles.primary}
                          label={TRANSLATIONS.GIFTCARD_BOX_CTA}
                          size={ButtonSizes.xs}
                          redirect={`${baseUrl}${TRANSLATIONS.GIFTCARD_LINK}/`}
                        />
                      </div>
                      <div className="dropdown__section">
                        {giftIdeas.slice(0, 6).map((g) => (
                          <CircleCard
                            key={g.title}
                            caption={g.title}
                            link={`${baseUrl}/${g.url}/`}
                            image={`${endpoints.bucket}gift-landings/${g.url}.jpg`}
                          />
                        ))}
                      </div>
                      {giftIdeas.length > 6 && (
                        <div className="dropdown__divider"></div>
                      )}
                      <div className="dropdown__section">
                        {giftIdeas.slice(6).map((g) => (
                          <CircleCard
                            key={g.title}
                            size={CircleCardSizes.small}
                            caption={g.title}
                            link={`${baseUrl}/${g.url}/`}
                            image={`${endpoints.bucket}gift-landings/${g.url}.jpg`}
                          />
                        ))}
                      </div>
                    </div>
                  </Dropdown>
                </div>
              )}
            </div>,
            <Button
              key={app_main_wpml.activity}
              style={
                isTransparent
                  ? ButtonStyles.textInvertUnderlined
                  : ButtonStyles.textUnderlined
              }
              label={app_main_wpml.activity}
              iconLeft={
                <BetaIcon
                  name={'compass'}
                  color={isTransparent ? IconColors.ghost : IconColors.regular}
                  size={IconSizes[16]}
                />
              }
              iconRight={isSecondaryMenuOpen ? chevronUp : chevronDown}
              onClick={() => ToggleSecondaryMenu(!isSecondaryMenuOpen)}
            />,
            <>
              {isSpanishEnv && (
                <Button
                  key={app_main_wpml.became_partner}
                  style={
                    isTransparent
                      ? ButtonStyles.textInvertUnderlined
                      : ButtonStyles.textUnderlined
                  }
                  label={app_main_wpml.became_partner}
                  iconLeft={
                    <BetaIcon
                      name={'partner'}
                      color={
                        isTransparent ? IconColors.ghost : IconColors.regular
                      }
                      size={IconSizes[16]}
                    />
                  }
                  onClick={() => {
                    ToggleSecondaryMenu(false);
                    window.location.href = pages.partnership;
                  }}
                />
              )}
            </>,
            <>
              {
                <Button
                  key={app_main_wpml.favourite}
                  style={
                    isTransparent
                      ? ButtonStyles.textInvertUnderlined
                      : ButtonStyles.textUnderlined
                  }
                  label={app_main_wpml.favourite}
                  iconLeft={
                    <BetaIcon
                      name={'favourite'}
                      color={
                        isTransparent ? IconColors.ghost : IconColors.regular
                      }
                      size={IconSizes[16]}
                    />
                  }
                  onClick={() => {
                    ToggleSecondaryMenu(false);
                    if (isAuthenticated) {
                      window.location.href = pages.wishList;
                    } else {
                      dispatch(action_openModalLikeListing());
                    }
                  }}
                />
              }
            </>,
            <>
              {
                <Button
                  key={app_main_wpml.search_history}
                  style={
                    isTransparent
                      ? ButtonStyles.textInvertUnderlined
                      : ButtonStyles.textUnderlined
                  }
                  label={app_main_wpml.search_history}
                  iconLeft={
                    <BetaIcon
                      name={'history'}
                      color={
                        isTransparent ? IconColors.ghost : IconColors.regular
                      }
                      size={IconSizes[16]}
                    />
                  }
                  redirect={pages.historyList}
                />
              }
            </>,
            <>
              {
                <div key={language_fullname} style={{ position: 'relative' }}>
                  <Button
                    style={
                      isTransparent
                        ? ButtonStyles.textInvertUnderlined
                        : ButtonStyles.textUnderlined
                    }
                    label={language_fullname}
                    iconRight={
                      isLanguagesDropdownOpen ? chevronUp : chevronDown
                    }
                    iconLeft={
                      <BetaIcon
                        name={'language'}
                        color={
                          isTransparent ? IconColors.ghost : IconColors.regular
                        }
                        size={IconSizes[16]}
                      />
                    }
                    onClick={() => {
                      ToggleSecondaryMenu(false);
                      setIsLanguagesDropdownOpen(!isLanguagesDropdownOpen);
                    }}
                  />
                  <Dropdown
                    isBeta={true}
                    position={DROPDOWN_POSITIONS.NAVBAR}
                    isOpen={isLanguagesDropdownOpen}
                  >
                    {freedomeConfig.languages.map((language, index) => (
                      <a
                        key={index}
                        className="dropdown__navbar__item"
                        href={language.url}
                      >
                        <BetaIcon name={`${language.code}Lang`} />
                        {language.fullname}
                      </a>
                    ))}
                  </Dropdown>
                </div>
              }
            </>,
            <>
              {
                <div
                  key="user_area"
                  style={{ position: 'relative' }}
                  ref={rightDelimiterRef}
                >
                  <Button
                    style={
                      isTransparent ? ButtonStyles.ghost : ButtonStyles.empty
                    }
                    iconLeft={
                      <BetaIcon
                        name={'hamburger'}
                        color={
                          isTransparent ? IconColors.ghost : IconColors.regular
                        }
                        size={IconSizes[16]}
                      />
                    }
                    iconRight={profile()}
                    onClick={() => {
                      ToggleSecondaryMenu(false);
                      setIsPersonalAreaDropdownOpen(
                        !isPersonalAreaDropdownOpen
                      );
                    }}
                  />
                  <Dropdown
                    isBeta={true}
                    position={DROPDOWN_POSITIONS.LOGIN}
                    isOpen={isPersonalAreaDropdownOpen}
                  >
                    {isAuthenticated ? (
                      <>
                        {user && user.role === ROLES.CUSTOMER ? (
                          <>
                            <div
                              className="dropdown__navbar__item"
                              onClick={() => {
                                window.location.href = pages.orderList;
                              }}
                            >
                              <BetaIcon name={'ticket'} size={IconSizes[16]} />
                              {app_main_wpml.reservations}
                            </div>
                            <div
                              className="dropdown__navbar__item"
                              onClick={() => {
                                window.location.href = pages.wishList;
                              }}
                            >
                              <BetaIcon
                                name={'favourite'}
                                size={IconSizes[16]}
                              />
                              {app_main_wpml.favourite}
                            </div>
                            <div
                              className="dropdown__navbar__item"
                              onClick={() => {
                                window.location.href = pages.profile;
                              }}
                            >
                              <BetaIcon name={'user'} size={IconSizes[16]} />
                              {app_main_wpml.profile}
                            </div>
                            <div
                              className="dropdown__navbar__item"
                              onClick={() => logout()}
                            >
                              <BetaIcon name={'logout'} size={IconSizes[16]} />
                              {app_main_wpml.logout}
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className="dropdown__navbar__item"
                              onClick={() => {
                                window.location.href =
                                  window.freedomeConfig.endpoints.dashboard;
                              }}
                            >
                              {app_main_wpml.dashboard}
                            </div>
                            <div
                              className="dropdown__navbar__item"
                              onClick={() => logout()}
                            >
                              {app_main_wpml.logout}
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div
                          className="dropdown__navbar__item"
                          onClick={() => loginWithRedirect()}
                        >
                          {app_main_wpml.login}
                        </div>
                        <ModalCustomerSignup
                          key="register"
                          layout="beta-navbar"
                          prefixesAreVisible={props.prefixesAreVisible}
                        />
                      </>
                    )}
                    <div
                      className="dropdown__navbar__item"
                      onClick={() => (window.location.href = pages.contactUs)}
                    >
                      {app_main_wpml.support_center}
                    </div>
                  </Dropdown>
                </div>
              }
            </>,
          ]}
        ></HeaderMenu>
      </CSSTransition>
      <div className="slider-header-container">
        <CSSTransition
          classNames="header-menu--secondary--slider"
          in={isSecondaryMenuOpen}
          timeout={0}
        >
          <HeaderMenu
            key="secondary"
            style={HeaderMenuStyles.secondary}
            isOpen={isSecondaryMenuOpen}
            centerChildren={[
              <Button
                key={app_main_wpml.most_popular}
                style={
                  ButtonStyles.textUnderlined +
                  (togglePopularDropdown ? '--active' : '')
                }
                label={app_main_wpml.most_popular}
                iconLeft={
                  <BetaIcon
                    name={'star'}
                    color={IconColors.regular}
                    size={IconSizes[16]}
                  />
                }
                onClick={() => {
                  closeAllDropdowns();
                  setTogglePopularDropdown(!togglePopularDropdown);
                }}
              />,
              popularCategories && <Dropdown
                key="popularCategories_Dropdown"
                isBeta={true}
                position={DROPDOWN_POSITIONS.NAVBAR_SECONDARY}
                isOpen={togglePopularDropdown}
                rightestPixel={rightDelimiterForDropdown}
              >
                {dropDownContentFromCategories(
                  popularCategories,
                  pages.catalogue,
                  true
                )}
              </Dropdown>,
              props.categoriesByPopularity?.map((category) =>
                categorySectionMaker(category)
              ),
            ]}
          />
        </CSSTransition>
      </div>
    </div>
  );
};

ViewDesktop.propTypes = {
  prefixesAreVisible: PropTypes.string,
};

export default ViewDesktop;
